const PREFIX = 'bravissimo/account/';

export const UPDATE_PERSONAL_DETAILS_REQUEST = `${PREFIX}UPDATE_PERSONAL_DETAILS_REQUEST`;
export const UPDATE_PERSONAL_DETAILS_FAILURE = `${PREFIX}UPDATE_PERSONAL_DETAILS_FAILURE`;
export const UPDATE_PERSONAL_DETAILS_SUCCESS = `${PREFIX}UPDATE_PERSONAL_DETAILS_SUCCESS`;
export const PERSONAL_DETAILS_CLOSE_MESSAGES = `${PREFIX}PERSONAL_DETAILS_CLOSE_MESSAGES`;
